// // // const finalReviewReports = [
// // //   { label: "Anthropometry", slug: "anthropometry" },
// // //   { label: "Eating Behaviour", slug: "eating-behaviour" },
// // //   { label: "Autism Screening", slug: "autism-screening" },
// // //   { label: "Sensory Profile", slug: "sensory-profile" },
// // //   { label: "Sleep Health", slug: "sleep-health" },
// // //   { label: "Seizure Risk", slug: "seizure-risk" },
// // //   { label: "Lab", slug: "lab" },
// // //   { label: "Audiology", slug: "audiology" },
// // //   { label: "Vision", slug: "vision" },
// // //   { label: "Dental", slug: "dental" },
// // //   { label: "Atopic March", slug: "atopic-march" },
// // //   { label: "Dermatology", slug: "dermatology" },
// // //   { label: "Mallampati", slug: "mallampati" },
// // //   { label: "PEDS DMAL", slug: "peds-dmal" },
// // //   { label: "Growth Chart", slug: "growth-chart" },
// // //   { label: "General Wellness", slug: "general-wellness", special: true },
// // //   { label: "Health History", slug: "health-history" },
// // // ];

// // // export default finalReviewReports;


// // // // const finalReviewReports = [

// // // // {
// // // //   label: "Anthropometry",
// // // //   apiRoute: "anthropometry"
// // // // },

// // // // {
// // // //   label: "Diet & Nutrition",
// // // //   apiRoute: "diet-nutrition"
// // // // },

// // // // {
// // // //   label: "Autism Screening",
// // // //   apiRoute: "autism-screening"
// // // // },

// // // // {
// // // //   label: "Sensory Profile",
// // // //   apiRoute: "sensory-profile"
// // // // },

// // // // {
// // // //   label: "Sleep Health",
// // // //   apiRoute: "sleep-health"
// // // // },

// // // // {
// // // //   label: "Seizure Risk",
// // // //   apiRoute: "seizures-epilepsy"
// // // // },

// // // // {
// // // //   label: "Lab",
// // // //   apiRoute: "lab"
// // // // },

// // // // {
// // // //   label: "Audiology",
// // // //   apiRoute: "audiology"
// // // // },

// // // // {
// // // //   label: "Vision",
// // // //   apiRoute: "vision"
// // // // },

// // // // {
// // // //   label: "Dental",
// // // //   apiRoute: "dental"
// // // // },

// // // // {
// // // //   label: "Atopic March",
// // // //   apiRoute: "atopic-march"
// // // // },

// // // // {
// // // //   label: "Dermatology",
// // // //   apiRoute: "dermatology"
// // // // },

// // // // {
// // // //   label: "Mallampati",
// // // //   apiRoute: "mallampati"
// // // // },

// // // // {
// // // //   label: "PEDS DMAL",
// // // //   apiRoute: "peds-dmal"
// // // // },

// // // // {
// // // //   label: "Growth Chart",
// // // //   apiRoute: "growth-chart"
// // // // },

// // // // {
// // // //   label: "General Wellness",
// // // //   apiRoute: "general-wellness",
// // // //   special: true
// // // // },

// // // // {
// // // //   label: "Health History",
// // // //   apiRoute: "health-history"
// // // // }

// // // // ];

// // // // export default finalReviewReports;








// // // src/data/finalReviewReports.ts

// // export interface ReviewReport {
// //   label: string;
// //   slug: string;
// //   special?: boolean;
// // }

// // const finalReviewReports: ReviewReport[] = [
// //   { label: "Anthropometry", slug: "anthropometry" },
// //   { label: "Eating Behaviour", slug: "eating-behaviours" }, // Updated to match Postman
// //   { label: "Autism Screening", slug: "autism-screening" },
// //   { label: "Sensory Profile", slug: "sensory-profile" },
// //   { label: "Sleep Health", slug: "sleep-health" },
// //   { label: "Lab", slug: "blood-examination" },           // Updated from 'lab' to 'blood-examination'
// //   { label: "Audiology", slug: "audiology-screening" },    // Updated from 'audiology' to 'audiology-screening'
// //   { label: "Vision", slug: "vision-screening" },          // Updated from 'vision' to 'vision-screening'
// //   { label: "Dental", slug: "dental" },
// //   { label: "Atopic March", slug: "atopic-march-risk" },   // Updated to match Postman
// //   { label: "Dermatology", slug: "atopic-dermatitis-risk" }, // Updated to match Postman
// //   { label: "Mallampati", slug: "mallampati-classification" }, // Updated to match Postman
// //   { label: "General Wellness", slug: "general-wellness", special: true },
// //   { label: "Health History", slug: "health-history" },
// // ];

// // export default finalReviewReports;


// // src/data/finalReviewReports.ts

// export interface ReviewReport {
//   label: string;
//   slug: string;
//   special?: boolean;
// }

// const finalReviewReports: ReviewReport[] = [
//   { label: "Anthropometry", slug: "anthropometry" },
//   { label: "Eating Behaviour", slug: "eating-behaviours" },      // Postman: eating-behaviours
//   { label: "Autism Screening", slug: "autism-screening" },
//   { label: "Sensory Profile", slug: "sensory-profile" },
//   { label: "Sleep Health", slug: "sleep-health" },
//   { label: "Seizure Risk", slug: "seizures-epilepsy" },          // Postman: seizures-epilepsy
//   { label: "Lab", slug: "blood-examination" },                   // Postman: blood-examination
//   { label: "Audiology", slug: "audiology-screening" },            // Postman: audiology-screening
//   { label: "Vision", slug: "vision-screening" },                  // Postman: vision-screening
//   { label: "Dental", slug: "dental" },
//   { label: "Atopic March", slug: "atopic-march-risk" },           // Postman: atopic-march-risk
//   { label: "Dermatology", slug: "atopic-dermatitis-risk" },       // Postman: atopic-dermatitis-risk
//   { label: "Mallampati", slug: "mallampati-classification" },     // Postman: mallampati-classification
//   { label: "PEDS DMAL", slug: "developmental-milestones" },      // Postman: developmental-milestones
//   { label: "Growth Chart", slug: "diet-nutrition" },
//   { label: "General Wellness", slug: "general-wellness", special: true }, // Special case
//   { label: "Health History", slug: "health-history" },
// ];

// export default finalReviewReports;



// src/data/finalReviewReports.ts

export interface ReviewReport {
  label: string;
  slug: string;
  special?: boolean;
}

const finalReviewReports: ReviewReport[] = [
  { label: "General Wellness & Lifestyle", slug: "01_general_wellness", special: true },
  { label: "Growth & Vitals", slug: "02_growth_vitals" },
  { label: "Diet & Nutrition", slug: "03_diet_nutrition" },
  { label: "Sleep Health", slug: "04_sleep_health" },
  { label: "Sensory Profile", slug: "05_sensory_profile" },
  { label: "Developmental Milestones", slug: "06_developmental_milestones" },
  { label: "Seizures & Epilepsy", slug: "07_seizures_epilepsy" },
  { label: "Allergies & Atopy", slug: "08_allergies_atopy" },
  { label: "Skin & Dermatology", slug: "09_skin_dermatology" },
  { label: "Hearing", slug: "10_hearing" },
  { label: "Vision", slug: "11_vision" },
  { label: "Dental Health", slug: "12_dental_health" },
  { label: "Blood Investigations", slug: "13_blood_investigations" },
];

export default finalReviewReports;